import React from 'react';
import fr from 'facet-rest';
import {
  FDBodyText, FDClickableText, FDContentContainer, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import {
  ModelUpdateCard,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPortfolioUpdatesStepTemplate/ModelUpdateCard';
import { useRightColumnContext } from 'Context/RightColumnContext';
import { dataAttrs, testAttr } from 'Helpers/Testing';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import MetaControl from 'Components/UI/Meta/MetaControl';
import {
  metaOverrideSet as ScenarioSelectionMetaOverrideSet,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioSelectionRedefinedStepLayoutWithContentHeader/metaOverrideSet';
import ScenarioQuestionPicker
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioQuestionPicker';
import { RoadmapDeliverableLeftNav } from 'Components/UI/roadmapDeliverable/leftNav';
import { RoadmapDeliverableNav } from '../Wrapper/RoadmapDeliverableNav';
import { RoadmapDeliverableHeader } from '../Wrapper/RoadmapDeliverableHeader';

export const RoadmapDeliverablePortfolioUpdatesContent = () => {
  const { resource } = useMetaLayoutContext();
  const { loadRightColumnCollectionLink } = useRightColumnContext();
  const { loadPageContentLink, isPageContentLoading } = usePageContentContext();
  useBoneBackgroundColor();

  if (!resource) {
    return null;
  }

  const backButtonPrompt = resource.withRelationship(fr.relationships.back.name,
    (rel) => rel.meta('prompt'),
    () => null);

  const askMyPlannerClickableText = resource.withRelationship(fr.relationships.justAskMyPlanner.name,
    (rel) => (
      <FDBodyText value={<>Any questions?{' '}<FDClickableText appearance="standalone" label={rel.meta('prompt')} onClick={() => loadRightColumnCollectionLink(rel.link('related'))} /></>} />
    ),
    () => null);

  const prevButton = resource.withRelationship(fr.relationships.previousLink.name,
    (rel) => (
      <FDPrimaryActionButton
        disabled={!!rel.meta('disabled')}
        label={backButtonPrompt ?? rel.meta('prompt')}
        loading={!!isPageContentLoading}
        onClick={() => {
          loadPageContentLink(rel.link('related'));
        }}
        {...dataAttrs('back-btn')}
      />
    ),
    () => null);

  return (
    <>
      {/* Custom header for navigation */}
      <FDContentContainer maxWidth={'xl'}>
        <RoadmapDeliverableNav disabled navAwayRelationship={resource.relationship(fr.relationships.navigateAway.name)} />
        <ScenarioQuestionPicker />
        <RoadmapDeliverableLeftNav />
      </FDContentContainer>

      {/* content */}
      <FDContentContainer maxWidth={'md'}>
        <FDStack direction={'column'} spacing={3} alignItems={'center'}>
          <RoadmapDeliverableHeader resource={resource} />
          <FDStack direction={'column'} alignItems={'center'} spacing={3} width={'100%'}>
            {askMyPlannerClickableText}
            <FDStack direction={'column'} paddingY={2} spacing={2} width={'100%'}>
              {resource.attr('modelUpdates').resources().list().map((modelUpdateResource, i) => (
                <ModelUpdateCard key={modelUpdateResource.id()} modelUpdateResource={modelUpdateResource} dataAttrs={{ ...dataAttrs('model-update-card', resource, { [testAttr.dataIndex]: i }) }} />
              ))}
            </FDStack>
          </FDStack>
          {prevButton}
          <FDStack direction={'row'} alignItems={'center'} paddingY={3} flex={1}>
            <MetaControl attrName={'disclaimerText'} resource={resource} metaOverrideSet={ScenarioSelectionMetaOverrideSet} />
          </FDStack>
        </FDStack>
      </FDContentContainer>
    </>
  );
};
